// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.fvqPBtSoGlIYConweKuS {
  color: #0669B3;
  font-size: 18px;
  line-height: 1.4;
  padding: 16px 16px 8px;
  display: flex;
  flex-direction: column;
}
@media (max-width: 768px) {
  .fvqPBtSoGlIYConweKuS {
    font-size: 16px;
  }
}

.V98iROEWHkdLBstejdVr {
  font-weight: 700;
  margin: 0 0 32px;
  color: #0669B3;
  font-size: 1.75em;
  line-height: 1.2;
}
@media (max-width: 768px) {
  .V98iROEWHkdLBstejdVr {
    font-size: 1.5em;
  }
}

.gE2iHm45gPQN1IxzykfI {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-left: 12px;
  padding-left: 16px;
  border-left: 3px solid rgba(6, 105, 179, 0.35);
}

.KdmukJYqNkpAK0EClGil {
  font-weight: 700;
  margin: 0 0 10px;
  color: #0669B3;
  font-size: 1.35em;
}

.ga2dRMCZ0MzOeyKBKsmP {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.a32qtOlFSyCdtOl2Ke8z {
  font-weight: 700;
  font-size: 1.1em;
}

.ddmdGfdN6ibozXIHUoYD {
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/SchoolReportCardStatistics.module.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,cD8BS;EC7BT,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;AAKJ;AAHI;EARJ;IASQ,eAAA;EAMN;AACF;;AAHA;EACI,gBAAA;EACA,gBAAA;EACA,cDeS;ECdT,iBAAA;EACA,gBAAA;AAMJ;AAJI;EAPJ;IAQQ,gBAAA;EAON;AACF;;AAJA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;AAOJ;;AAJA;EACI,gBAAA;EACA,gBAAA;EACA,cDNS;ECOT,iBAAA;AAOJ;;AAJA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAOJ;;AAJA;EACI,gBAAA;EACA,gBAAA;AAOJ;;AAJA;EACI,cAAA;AAOJ","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n\n.container {\n    color: $pearl-blue;\n    font-size: 18px;\n    line-height: 1.4;\n    padding: 16px 16px 8px;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 768px) {\n        font-size: 16px;\n    }\n}\n\n.schoolName {\n    font-weight: 700;\n    margin: 0 0 32px;\n    color: $pearl-blue;\n    font-size: 1.75em;\n    line-height: 1.2;\n\n    @media (max-width: 768px) {\n        font-size: 1.5em;\n    }\n}\n\n.statsBlock {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    margin-left: 12px;\n    padding-left: 16px;\n    border-left: 3px solid rgba($pearl-blue, 0.35);\n}\n\n.title {\n    font-weight: 700;\n    margin: 0 0 10px;\n    color: $pearl-blue;\n    font-size: 1.35em;\n}\n\n.group {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n}\n\n.label {\n    font-weight: 700;\n    font-size: 1.1em;\n}\n\n.summary {\n    display: block;\n}\n"],"sourceRoot":""}]);
// Exports
export var container = `fvqPBtSoGlIYConweKuS`;
export var schoolName = `V98iROEWHkdLBstejdVr`;
export var statsBlock = `gE2iHm45gPQN1IxzykfI`;
export var title = `KdmukJYqNkpAK0EClGil`;
export var group = `ga2dRMCZ0MzOeyKBKsmP`;
export var label = `a32qtOlFSyCdtOl2Ke8z`;
export var summary = `ddmdGfdN6ibozXIHUoYD`;
export default ___CSS_LOADER_EXPORT___;
